import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 48 48"
    >
      <g>
        <path
          fill={colorValue}
          d="M45 22.5a9.011 9.011 0 00-9-9h-7.497c-.097 0-9.821-.13-19.074-7.89A3 3 0 004.5 7.908v29.187A2.97 2.97 0 006.23 39.81a2.984 2.984 0 003.199-.421c7.102-5.957 14.482-7.417 17.571-7.774v6.581a2.993 2.993 0 001.336 2.496l2.061 1.375a3.001 3.001 0 004.574-1.769l2.22-8.88a9.012 9.012 0 007.81-8.919zM32.06 39.571L30 38.197V31.5h4.079l-2.018 8.071zM36 28.501h-6v-12h6a6 6 0 110 12z"
        ></path>
      </g>
    </svg>
  );
};
